import React,{Component} from 'react';
import "./style.less"
import {NavBar} from "antd-mobile";
const rule = require('../../../common/image/rule.png');
const activiText = require('../../../common/image/activiText.png');
const mtlogo = require('../../../common/image/mtlogo.png');
export default class Regulation extends Component{
    constructor(props) {
        super(props);
    }
    render(){
        return(
            <div className="regulation">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}></i>}
                >推荐有礼</NavBar>
                <div className="con">
                    <div className="img"><img src={rule} alt=""/></div>
                    <div className="bottom">
                        <img src={activiText} alt=""/>
                        <div className="text">
                            <p>1、乘车积分仅限民途出行新注册用户领取，首次注册送20积分，邀请好友注册并成功再享10积分，不限次数。</p>
                            <p>2、同一手机账号，同一设备，同一支付账号视为同一用户</p>
                            <p>3、新用户乘车积分不参与其它优惠券叠加。</p>
                            <p>4、您邀请的好友需通过民途出行公众号或民途出行APP注册。</p>
                            <p>5、1积分抵扣乘车费用1元，单次积分使用根据区域票价来定，长期有效。</p>
                            <p>6、如有其它疑问咨询民途出行客服。</p>
                        </div>
                    </div>
                    <div className="logoBox">
                        <img src={mtlogo} alt=""/>
                    </div>
                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/Regulation/index.js